import _isNil from 'lodash/isNil';

export const convertMetersToFeet = (meters) => {
    if (!Number.isNaN(meters) && meters === 0) {
        return "0 '";
    }

    // Convert meters to inches
    if (!meters) {
        return null;
    }
    const inches = meters * 39.37;

    // Convert inches to feet and inches
    const feet = Math.floor(inches / 12);
    const remainingInches = Math.round(inches % 12);
    if (remainingInches === 12) {
        return feet + 1 + "' ";
    }

    const inchesDisplay = remainingInches === 0 ? '' : remainingInches + '"';

    return feet + "' " + inchesDisplay;
};

export const roundToFourSigFigs = (value: number): number | null => {
    if (typeof value !== 'number' && typeof value !== 'string') {
        return null;
    }

    if (value === 0) {
        return 0;
    }

    if (Math.abs(value) >= 100) {
        // If there are 3 or more digits to the left of the decimal point, round to 2 decimal places.
        return Math.round(value * 100) / 100;
    }

    return parseFloat(Number(value).toPrecision(4));
};

export const convertRadiansToDegrees = (value: number): number => {
    if (typeof value !== 'number') {
        return null;
    }

    const returnVal = ((180.0 / Math.PI) * value) % 360.0;
    return returnVal;
};

export function invertRadians(angle: number) {
    return (angle + Math.PI) % (2 * Math.PI);
}

export function getPercentageStringFromDecimal(
    decimal: number,
    toFloor = true
): string {
    const pct = toFloor ? Math.floor(decimal * 100) : Math.ceil(decimal * 100);

    return pct.toFixed(0);
}

export function isValidNumber(input: number): boolean {
    return !_isNil(input) && !Number.isNaN(input);
}
